import React from "react";

const SitemapIcon = () => {
  return (
    <>
                      <svg
                        _ngcontent-serverApp-c140=""
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25px"
                        height="25px"
                        viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g
                          _ngcontent-serverApp-c140=""
                          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          fill="#000000"
                          stroke="none"
                        >
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M304 4320 c-348 -123 -408 -585 -103 -789 74 -50 150 -72 244 -72 94
0 170 22 245 73 306 204 243 668 -108 789 -73 25 -207 25 -278 -1z"
                          ></path>
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M1508 4215 c-289 -106 -295 -512 -9 -627 l56 -23 1600 -3 c1081 -2
1622 1 1668 8 87 13 152 46 204 103 52 57 68 88 84 165 32 154 -58 316 -207
372 -54 20 -69 20 -1707 19 -1374 0 -1658 -3 -1689 -14z"
                          ></path>
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M303 2980 c-294 -104 -395 -464 -198 -705 171 -207 510 -207 680 1
198 241 95 603 -202 705 -74 25 -207 25 -280 -1z"
                          ></path>
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M1574 2890 c-214 -32 -341 -249 -264 -453 29 -78 107 -156 187 -188
l58 -24 1645 0 1645 0 59 24 c108 43 183 134 207 249 32 154 -56 312 -207 373
l-59 24 -1610 1 c-885 1 -1633 -2 -1661 -6z"
                          ></path>
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M395 1659 c-80 -9 -129 -27 -193 -69 -308 -206 -246 -670 106 -791
74 -26 200 -26 274 0 206 71 334 279 300 486 -21 130 -87 233 -193 304 -88 59
-188 83 -294 70z"
                          ></path>
                          <path
                            _ngcontent-serverApp-c140=""
                            d="M1574 1550 c-214 -31 -341 -248 -264 -453 26 -69 94 -143 165 -177
l50 -25 1662 -3 c1652 -2 1662 -2 1716 18 150 56 240 218 208 372 -16 77 -32
108 -84 165 -51 56 -116 89 -198 103 -74 12 -3173 12 -3255 0z"
                          ></path>
                        </g>
                      </svg>{" "}
                      </>
)
};

export default SitemapIcon;
